module.exports = __webpack_public_path__ + "img/P08-IS2007-1018.7d535ed0.jpg";